// extracted by mini-css-extract-plugin
export default {"headlineIllustration":"style_headlineIllustration__v8MCG"};